
import { PageQuery } from '@/mixins/page_query';
import { Component, Mixins, Vue } from 'vue-property-decorator';
import { iGamMarkingModel, iGameMarkingQuery } from '@/interface/game-discussion-manage';
import { getGameForum, getForumSetting, UpdateForumSetting } from '@/api/game-discusstion-manage';
import { toast } from '@/utils/common';
import UserBlackList from '../user-black-list/index.vue';
@Component({
  components: { UserBlackList },
})
export default class GameMarking extends Mixins(PageQuery) {
  discussable = true;
  loading: boolean = false;
  visible: boolean = false;

  private query: iGameMarkingQuery = {
    game_id: null,
    game_name: '',
    content_keywords: '',
    num_of_discussion: '1',
  };
  tableData: iGamMarkingModel[] = [];
  public page_query = {
    page: 1,
    page_size: 30,
  };
  handelClose() {
    this.visible = false;
  }
  handleUserBlackList() {
    this.visible = true;
  }
  handleSizeChange(val: number) {
    // Cookies.set('page_size_ck', val.toString());
    this.page_query.page_size = val;
    this.page_query.page = 1;
    this.pageFn && this.pageFn();
  }
  handleCurrentChange(val: number) {
    this.page_query.page = val;
    this.pageFn && this.pageFn();
  }
  numOfdiscussionData = [
    {
      id: '',
      name: '选择是否有讨论',
    },
    {
      id: '0',
      name: '无讨论',
    },
    {
      id: '1',
      name: ' 讨论数大于0',
    },
  ];
  search() {
    if (this.query.content_keywords != '') {
      const data = {
        content_keywords: this.query.content_keywords,
        game_id: this.query.game_id,
        game_name: this.query.game_name,
      };
      this.$emit('goSearch', data);
    } else {
      this.page_query.page = 1;
      this.getSearchList();
    }
  }

  async getSearchList() {
    try {
      this.loading = true;
      const res = await getGameForum({ ...this.page_query, ...this.query });
      this.tableData = res.data.rows;

      this.total = res.data.total;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  async getForumSetting() {
    try {
      this.loading = true;
      const res = await getForumSetting();
      this.discussable = res.data.discussable;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  async handleSwitchDiscussable() {
    try {
      this.loading = true;
      const res = await UpdateForumSetting({ discussable: this.discussable });
      if (res.code == 0) {
        this.getForumSetting();
      } else {
        toast(res.msg, 'error');
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  goDiscussion(row: iGamMarkingModel) {
    this.$emit('goDiscussion', row);
  }
  mounted() {
    this.pageFn = this.getSearchList;
    this.getSearchList();
    this.getForumSetting();
    // this.tableData = [{ game_id: 1, game_name: '232', score: 9.0, num_of_discussion: 3 }];
  }
}
